export default {
    oma: {
        fromDate: "From Date",
        toDate: "To Date",
        selectDate: "Select Date",
        cancel: "CANCEL",
        avocadoTreesList: "Avocado Trees List",
        addTreesManually: "Add Tree GeoLocation Manually",
        confirmationTitle: "Confirmation",
        confirmationMessage: "Avocadao Tree has benn added/edited successfully",
        addTreesBulk: "Import trees in bulk",
        addNewFarm: "Select Farm",
        selectFarm: "Select Farm",
        selectZone: "Select Zone",
        treeId: "Tree Id",
        treeName: "Tree Name",
        zoneId: "Zone Id",
        latitude: "Latitude",
        longitude: "Longitude",
        altitude: "Altitude",
        timestamp: "timestamp",
        avocadoTrees: "Avocado Trees",
        //Land suitibility
        landSuitibility: "Land Suitability",
        landSuitibilityReport: "Land Suitability Report",
        generateNewReport: "Generate New Report",
        operatorName: "Operator Name",
        issueDate: "Issue Date",
        chooseYourLocation: "Chose Your Location",
        getLandEvaluation: "Get land evaluation",
        downloadPdfReport: "Download pdf report",
        pleaseEnterCoordinateText:
          "Please enter coordinate (longitude and latitude) of the farm location to see its score. ",
        noRecordAvailable: "No results available.",
        overallScoreForLand: "Overall Score for Land Suitability",
        landEvaluation: "Land Evaluation",
        unsuitable: "Unsuitable",
        marginally: "Marginally",
        suitable: "Suitable",
        moderately: "Moderately",
        highly: "Highly",
        back: "Back",
        search: "Search",
        showResults: "Show Results",
        //weather analysis
        weatherAnalysisReport: "Weather Analysis Reports",
        weatherAnalysis: "Weather Analysis",
        weatherReport: "Weather Report",
        getWeatherAnalysis: "Get Weather Analysis",
        filterByDate: "Filter by Date",
        insertCoordinateText:
          "Insert the coordinates of the farm (or tree) location above, or use the map below to indicate the farm (or tree) location.",
        addTreeGeolocation: "Add Tree Geolocation",
        editTreeGeolocation: "Edit Tree Geolocation",
        plantationDate: "Date Planted",
        notes: "Notes",
        uploadTreeImages: "Upload Tree Images",
        valueAtTheCoordinatesOfInterest: "Value at the Coordinate of Interest",
        "Slope (%)": "Slope (%)",
        "Soil texture (USDA class)": "Soil texture (USDA class)",
        "Coarse fragments (vol%)": "Coarse fragments (vol%)",
        Land: "Land",
        "Artificial surfaces (type)": "Artificial surfaces (type)",
        "Proximity to Type 1 and 2 Roads (meters)":
          "Proximity to Type 1 and 2 Roads (meters)",
        "Soil Chemical Properties": "Soil Chemical Properties",
        "Soil Physical Properties": "Soil Physical Properties",
        "Soil organic carbon (%)": "Soil organic carbon (%)",
        "Soil pH": "Soil pH",
        "Soil salinity (ECe))": "Soil salinity (ECe))",
        "Mean annual temperature (°C)": "Mean annual temperature (°C)",
        Weather: "Weather",
        "Mean minimum temperature of coldest month (°C)":
          "Mean minimum temperature of coldest month (°C)",
        "Mean annual precipitation (mm)": "Mean annual precipitation (mm)",
        avocadoDetailNoUpdates: "No Updates",
        avocadoTreeDetail: "Tree Details",
        avocadoTreeDetailHeader: "Avocado Tree Details",
        avocadoTreeUpdates: "Avocado Tree Updates",
        avocadoAddImages: "Add New Images",
        addNewTreeImage: "Add New Tree Images",
        selectCountry: "Select Country",
        allRegions: "All Regions",
        avocadoDetailCard: {
          clientTreeId: "Tree ID",
          treeName: "Tree Name",
          latitude: "Latitude",
          longitude: "Longitude",
          altitude: "Altitude",
          zoneId: "Zone ID",
          createdAt: "Date & Time",
          plantationDate: "Date & Time",
          updatedAt: "Last Updated",
        },
        importCSVFormat: "Import CSV Format",
        importGeoJsonFormat: "Import GeoJSON Format",
        importShapeFilesFormat: "Import Shape Files Format",
        importXLSFormat: "Import XLS Format",
        importGeobufFormat: "Import Geobuf Format",
        importGeoPackageFormat: "Import GeoPackage Format",
        importTopoJsonFormat: "Import TopoJSON Format",
        avocadoTreeDetailsTableHeader: {
          updatedOn: "Updated On",
          updatedBy: "Updated By",
          notes: "Notes",
          noOfImages: "No. of Images",
          actions: "Action",
        },
        avocadoTreeView: "Tree View",
        avocadoFarmView: "Farm View",
        avocadoTreeDetailPopupTitle: "View Tree Details",
        dateOfInterest: "Date of Interest",
        maximumCloudCoverage: "Maximum Cloud Coverage",
        import: "Import",
        history: "History",
        downloandimport: "Download and Import",
        importantNote: "Important Note",
        downloadXlsFormat: "Download XLS Format",
        downloadCSVFormat: "Download CSV Format",
        downloadGeoJSONFormat: "Download GeoJSON Format",
        downloadTopoJSONFormat: "Download TopoJSON Format",
        downloadGeoPackageFormat: "Download GeoPackage Format",
        downloadGeobufFormat: "Download Geobuf Format",
        selectXLSFile: "Select XLS File",
        selectCSVFile: "Select CSV File",
        selectGeoJSONFile: "Select GeoJSON File",
        selectTopoJSONFile: "Select TopoJSON File",
        selectGeoPackageFile: "Select GeoPackage File",
        selectGeobufFile: "Select Geobuf File",
        OrDragDrop: "or drag and drop here",
        importTrees: "Import Trees",
        importantNoteDetail:
          "Please use the provided templates above for bulk uploads.\n" +
          "Other formats will result in failure.",
        fileName: "Filename",
        importedOn: "Imported On",
        status: "Status",
        actions: "Action",
        action: "Action",
        download: "Download",
        removeFile: "Remove File",
        importedTrees: "Imported Trees",
        geolocation: "Geolocation",
        "Export CSV Format": "Export CSV Format",
        "Export XLSX Format": "Export XLSX Format",
        "Export PDF Format": "Export PDF Format",
        noHistoryFound: "No History Found",
      }
}